import { Component, OnInit } from '@angular/core';
import { SsrService } from 'src/app/services/ssr/ssr.service';

@Component({
  selector: 'app-ravinder',
  templateUrl: './ravinder.component.html',
  styleUrls: ['./ravinder.component.scss']
})
export class RavinderComponent implements OnInit {
  result:{name:string ,title:string, link:string} [] = [];
  constructor(private ssrService : SsrService) { }

  ngOnInit(): void {
    this.result = this.ssrService.getRavinder();
  }

}
